import { connectedStore } from '../../../store';
import view from '../../../view';
import constants from '../../constants';
import template from '../../../template';

const { TEXT_COLOR_OPTIONS_VARIABLE } = constants;

const reloadCustomColorStylesheet = () => {
  const store = connectedStore.get();
  const state = store.getState();
  const variables = template.selectors.getVariables(state);
  const { querySelector } = variables[TEXT_COLOR_OPTIONS_VARIABLE][0];
  const liveDom = view.accessors.getLiveDocument();

  const stylesheetNode = liveDom.querySelector(querySelector);
  const cloneStylesheetNode = stylesheetNode.cloneNode(true);
  stylesheetNode.replaceWith(cloneStylesheetNode);
};

export default reloadCustomColorStylesheet;
